import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaEpiEvidencia'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const SetImg = (Id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/img/${Id}`, data, config)
const GetImgByVistoriaEpi = (Id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/img/${Id}`, data, config)
const GetAllImgByVistoria = (Id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/allImgvistoria/${Id}`, data, config)

const surveyepievidenceRepository = {
  GetImgByVistoriaEpi,
  SetImg,
  GetAllImgByVistoria
}

export default surveyepievidenceRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/surveyepievidence.js